import React from "react";
import { Link } from "react-router-dom";
import HeaderCss from "./Header.css";
import HeaderTop from "./HeaderTop";
import Image from "../../../assets/image/image";

const Header = ({ navs }) => {
  return (
    <HeaderCss.HeaderContainer>
      <HeaderTop></HeaderTop>
      <div className="HeaderContent">
        <Link to="/">
          <img alt="logo" src={Image.logo} />
        </Link>
        <div className="HeaderContentLink">
          {navs.map((data, index) => (
            <span key={index}>
              <Link to={`/${data.address}`}>{data.title}</Link>
            </span>
          ))}
        </div>
      </div>
    </HeaderCss.HeaderContainer>
  );
};

export default Header;
